import React from 'react';
import { EnfocadoLanding } from './pages/EnfocadoLanding';
export function App() {
  return <EnfocadoLanding data-id="element-0" />;
}